import * as Tone from "tone";

let drums: Tone.Instrument | null = null;
export async function loadDrums(): Promise<Tone.Instrument> {
  if (drums) {
    return drums;
  }
  return new Promise<Tone.Instrument>(resolve => {
    const sampler = new Tone.Sampler(
      {
        A0: require("../soundfont/NewDrumSamples/MP3/Snare Ghost.mp3"),
        A1: require("../soundfont/NewDrumSamples/MP3/Stacker.mp3"),
        A2: require("../soundfont/NewDrumSamples/MP3/3.mp3"),
        A7: require("../soundfont/NewDrumSamples/MP3/Cowbell.mp3"),
        Ab2: require("../soundfont/NewDrumSamples/MP3/Hi Hat Foot.mp3"),
        Ab7: require("../soundfont/NewDrumSamples/MP3/Buzz.mp3"),
        B1: require("../soundfont/NewDrumSamples/MP3/Kick.mp3"),
        B2: require("../soundfont/NewDrumSamples/MP3/4.mp3"),
        B7: require("../soundfont/NewDrumSamples/MP3/Snare Flam.mp3"),
        Bb0: require("../soundfont/NewDrumSamples/MP3/Snare Accent.mp3"),
        Bb2: require("../soundfont/NewDrumSamples/MP3/Hi Hat Open.mp3"),
        Bb7: require("../soundfont/NewDrumSamples/MP3/Rim.mp3"),
        C8: require("../soundfont/NewDrumSamples/MP3/Hi Hat Accent.mp3"),
        D2: require("../soundfont/NewDrumSamples/MP3/Snare Normal.mp3"),
        Db2: require("../soundfont/NewDrumSamples/MP3/Snare Cross Stick.mp3"),
        Db3: require("../soundfont/NewDrumSamples/MP3/Crash.mp3"),
        E3: require("../soundfont/NewDrumSamples/MP3/Stacker.mp3"),
        E5: require("../soundfont/NewDrumSamples/MP3/metronome1Count.mp3"),
        Eb3: require("../soundfont/NewDrumSamples/MP3/Ride.mp3"),
        F2: require("../soundfont/NewDrumSamples/MP3/1.mp3"),
        F3: require("../soundfont/NewDrumSamples/MP3/Bell.mp3"),
        F5: require("../soundfont/NewDrumSamples/MP3/metronomeClick.mp3"),
        G2: require("../soundfont/NewDrumSamples/MP3/2.mp3"),
        Gb2: require("../soundfont/NewDrumSamples/MP3/Hi Hat Normal.mp3"),
      },
      () => {
        drums = sampler;
        resolve(sampler);
      },
    );
  });
}



// WEBPACK FOOTER //
// ./src/instrument.ts